import type { InboundLineRow } from "./inboundApi";

export const INBOUND_UNKNOWN_PART_LABEL_SKU = "UNKNOWN PART";

export type InboundLineMpnDraftFields = {
  scanned_mpn: string;
  mpn_matched: boolean;
  unknown_mpn_confirmed: boolean;
  unknown_mpn_quantity: string;
  approved_component_id: string | null;
  manufacturer_name: string;
};

export type InboundMpnEntryState =
  | "not_required"
  | "pending"
  | "matched"
  | "blocked"
  | "unknown_confirmed";

export function lineRequiresMpnEntry(
  line: Pick<InboundLineRow, "requires_mpn_entry">,
): boolean {
  return line.requires_mpn_entry === true;
}

export function resolveInboundMpnEntryState(input: {
  line: Pick<InboundLineRow, "requires_mpn_entry">;
  draft: InboundLineMpnDraftFields;
}): InboundMpnEntryState {
  if (!lineRequiresMpnEntry(input.line)) return "not_required";
  if (input.draft.unknown_mpn_confirmed) return "unknown_confirmed";
  if (input.draft.mpn_matched && input.draft.approved_component_id != null) return "matched";
  const scanned = input.draft.scanned_mpn.trim();
  if (scanned === "") return "pending";
  return "blocked";
}

export function mpnEntryAllowsCounting(state: InboundMpnEntryState): boolean {
  return state === "not_required" || state === "matched";
}

export function countingUnknownMpnPath(_state: InboundMpnEntryState): boolean {
  return false;
}

export function buildInboundLineMpnDraftFromLine(
  line: Pick<
    InboundLineRow,
    | "scanned_mpn"
    | "approved_component_id"
    | "unknown_mpn_confirmed"
    | "unknown_mpn_quantity"
  >,
): InboundLineMpnDraftFields {
  const scannedMpn = line.scanned_mpn?.trim() ?? "";
  const approvedComponentId =
    line.approved_component_id != null && line.approved_component_id.trim() !== ""
      ? line.approved_component_id
      : null;
  return {
    scanned_mpn: scannedMpn,
    mpn_matched: approvedComponentId != null,
    unknown_mpn_confirmed: line.unknown_mpn_confirmed === true,
    unknown_mpn_quantity: line.unknown_mpn_quantity ?? "",
    approved_component_id: approvedComponentId,
    manufacturer_name: "",
  };
}

export function emptyInboundLineMpnDraftFields(): InboundLineMpnDraftFields {
  return {
    scanned_mpn: "",
    mpn_matched: false,
    unknown_mpn_confirmed: false,
    unknown_mpn_quantity: "",
    approved_component_id: null,
    manufacturer_name: "",
  };
}

export const INBOUND_RECEIVE_LINE_SCAN_PROMPT = {
  label: "Find line or scan",
  placeholder: "SKU, description, line number, or ARRIVED carton tag",
} as const;

export function findInboundOrderLineBySkuScan(
  lines: readonly Pick<InboundLineRow, "sku" | "source_item_id">[],
  scanned: string,
): Pick<InboundLineRow, "sku" | "source_item_id"> | null {
  const needle = scanned.trim().toLowerCase();
  if (needle === "") return null;
  return lines.find((line) => line.sku.trim().toLowerCase() === needle) ?? null;
}
